import { ItemInfo } from "@/features/matches";
import { cn } from "@/shared/lib";

import type { AssetView } from "../../api/AssetView";

type AssetIconProps = {
  asset: AssetView;
  size?: number;
  className?: string;
  // Название уже есть в тексте рядом: иконку экранный диктор пропускает.
  decorative?: boolean;
};

// У предмета магазина есть ветка (`slot`): его иконка по нажатию показывает описание. У героев
// и неизвестных предметов ветки нет — обычная картинка.

// Иконка героя или предмета с явными размерами, чтобы страница не прыгала при загрузке;
// иконка предмета — кнопка с его описанием.
// Иконки нет — плашка с первой буквой названия. Размер картинки — ещё и в `style`: preflight
// Tailwind ставит `img { height: auto }` поверх атрибута `height`, и в строке `flex` без
// выравнивания иконка тянулась на всю высоту соседа полосой.
export const AssetIcon = ({ asset, size = 44, className, decorative = false }: AssetIconProps) => {
  const classes = cn("shrink-0 rounded-lg bg-surface-raised object-cover", className);
  if (asset.iconUrl === null) {
    return (
      <span
        aria-hidden="true"
        style={{ width: size, height: size }}
        className={cn(classes, "inline-flex items-center justify-center font-display text-muted")}
      >
        {asset.name.slice(0, 1)}
      </span>
    );
  }
  const image = (
    <img
      src={asset.iconUrl}
      alt={decorative ? "" : asset.name}
      width={size}
      height={size}
      style={{ width: size, height: size }}
      loading="lazy"
      className={classes}
    />
  );
  return asset.slot === null ? (
    image
  ) : (
    <ItemInfo itemId={asset.id} name={asset.name}>
      {image}
    </ItemInfo>
  );
};
